export const VERSION = {
  appVersion: '1.1.1-25',
  buildDate: '2026-6-23 11:49:45',
};
